import adminAxiosInstance from "./api/adminAxiosInstance";

const searchGoldenBoxes = async (
  limit,
  offset,
  clientSearch,
  goldenBoxStatus,
  optionId
) => {
  const params = new URLSearchParams({
    limit,
    offset,
  });

  if (clientSearch) params.append("clientSearchTerm", clientSearch);
  if (goldenBoxStatus) params.append("goldenBoxStatus", goldenBoxStatus);
  if (optionId) params.append("optionId", optionId);

  const response = await adminAxiosInstance.get(
    `goldenbox/search?${params.toString()}`
  );
  return response.data;
};

const createGoldenBox = async (payload) => {
  // payload deve conter: { clientId, contractId, goldenOptionId, chosenStatus (opcional) }
  const response = await adminAxiosInstance.post(`goldenbox`, payload);
  return response.data;
};

const approveOrReject = async (goldenBoxId, approved) => {
  const payload = {
    goldenBoxId: goldenBoxId,
    approved: approved,
  };

  const response = await adminAxiosInstance.post(
    `goldenbox/approve-reject`,
    payload
  );
  return response.data;
};

const addProfit = async (goldenBoxId, amount) => {
  const payload = {
    goldenBoxId: goldenBoxId,
    amount: parseFloat(amount),
  };
  const response = await adminAxiosInstance.post(
    `goldenbox/add-profit`,
    payload
  );
  return response.data;
};

const updateDates = async (goldenBoxId, dates) => {
  const payload = {
    goldenBoxId: goldenBoxId,
    newDates: dates,
  };
  const response = await adminAxiosInstance.put(
    `goldenbox/update-dates`,
    payload
  );
  return response.data;
};

const searchWithdraws = async (limit, offset, clientSearch, status) => {
  const params = new URLSearchParams({
    limit,
    offset,
  });

  if (clientSearch) params.append("clientSearch", clientSearch);
  if (status) params.append("status", status);

  const response = await adminAxiosInstance.get(
    `goldenboxwithdraw/search?${params.toString()}`
  );
  return response.data;
};

const approveOrRejectWithdraw = async (withdrawId, approved) => {
  const payload = {
    withdrawId: withdrawId,
    approved: approved,
  };

  const response = await adminAxiosInstance.post(
    `goldenboxwithdraw/approve-reject`,
    payload
  );
  return response.data;
};

const getGeneralMetrics = async () => {
  const response = await adminAxiosInstance.get(`goldenbox/metrics`);
  return response.data;
};

export const goldenBoxAdminService = {
  searchGoldenBoxes,
  createGoldenBox, // <--- NOVA FUNÇÃO
  approveOrReject,
  addProfit,
  updateDates,
  searchWithdraws,
  approveOrRejectWithdraw,
  getGeneralMetrics
};
